import { NavigateFunction } from "react-router";
import {
  EmailVerificationRequest,
  EmailVerificationResponse,
  ErrorTypes,
  ProductUrls,
} from "_core/types";

import { fetchClient } from "_core/utils/fetchClient";

export const fetchVerifyEmail = async (
  verificationCode: string,
  navigate: NavigateFunction,
  setLoading: (isLoading: boolean) => void,
  API_URL: string
) => {
  try {
    const body: EmailVerificationRequest = {
      verification_code: verificationCode,
    };
    const { message } = await fetchClient<EmailVerificationResponse>({
      base: API_URL,
      path: "/v1/register-interest/email-verification",
      options: {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    });

    switch (message) {
      case "already verified":
        navigate(ProductUrls.ErrorPage, {
          state: { error: ErrorTypes.ALREADY_VERIFIED },
        });
        break;

      case "expired":
        navigate(ProductUrls.ErrorPage, {
          state: { error: ErrorTypes.EXPIRED },
        });
        break;

      case "success":
        navigate(ProductUrls.EmailConfirmation);
        break;

      default:
        break;
    }
  } catch (e) {
    navigate(ProductUrls.ErrorPage, {
      state: { error: ErrorTypes.OOPS },
    });
  } finally {
    setLoading(false);
  }
};
